import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getDisabledUsersRequest: ['response'],
    getDisabledUsersSuccess: ['response', 'loading'],
    getDisabledUsersFailure: ['error'],
})

export const getDisabledUsersTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: [],
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getDisabledUsersSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getDisabledUsersFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getDisabledUsersRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_DISABLED_USERS_REQUEST]: getDisabledUsersRequest,
    [Types.GET_DISABLED_USERS_SUCCESS]: getDisabledUsersSuccess,
    [Types.GET_DISABLED_USERS_FAILURE]: getDisabledUsersFailure,
})
